<aw-add-certificate-to-box [box]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-add-certificate-to-box>